import React from 'react'
import {FiMessageCircle, FiBell } from 'react-icons/fi'

export const Notifiable = () => {
    const [messageCount] = React.useState(759)
    const [notificationCount] = React.useState(2713)
    return (
       <React.Fragment>
            <li >
                <a href="/chat">
                    <FiMessageCircle />
                    <div className="counter">2579</div> 
                   {messageCount>0 &&  <div className="counter">{messageCount}</div> }
                </a>
                <div className="messaging_dropdown dropdown"></div>
            </li>
            <li>
                <a href="/notifications" >
                    <FiBell />
                   {notificationCount>0 &&  <div className="counter">{notificationCount}</div> }
                </a>
                <div className="notify_dropdown dropdown"></div> 
            </li>
       </React.Fragment>
    )

}